import Auth from '../auth';
export default class TcApiCustomer {
    isLoggedIn() {
        return Auth.getState().then((state) => {
            return state.loggedIn;
        });
    }
    getFirstName() {
        return Auth.getState().then((state) => {
            return state.firstName;
        });
    }
    getState() {
        return Auth.getState().then((state) => {
            return {
                loggedIn: state.loggedIn,
                firstName: state.firstName,
            };
        });
    }
}
